// apps/web/src/pages/vendas/fechamento/rascunho-api.ts — Fase 12, Plano 14 (FECH-02, D-18, R12-06).
// Cliente das escritas do rascunho fiscal (recalcular, selecionar modelo, ajustar, aprovar). A autorização real está na API
// (pv:fechar); 409 de versão vira `conflito` e o que o usuário digitou continua na tela até recarregar.
import type { RascunhoFiscalView } from '@pieltec/contracts';
import { apiMutate } from '../../../lib/csrf-fetch';
import { lerErroApi, MENSAGEM_FALHA_PV, MENSAGEM_SEM_PERMISSAO_PV } from '../../../lib/vendas/erro-api';

export const CODIGO_RASCUNHO_VERSAO_DESATUALIZADA = 'RASCUNHO_VERSAO_DESATUALIZADA';
export const MENSAGEM_RASCUNHO_DESATUALIZADO = 'Este rascunho foi alterado por outra pessoa. Recarregue para ver as mudanças.';
export const MENSAGEM_FALHA_RASCUNHO = MENSAGEM_FALHA_PV;
export const MENSAGEM_FALHA_RECARGA_RASCUNHO =
  'Não foi possível recarregar o rascunho. O que você digitou continua na tela; tente recarregar de novo.';
export const MENSAGEM_SEM_PERMISSAO_RASCUNHO = MENSAGEM_SEM_PERMISSAO_PV;

export type ResultadoRascunho =
  | { readonly tipo: 'ok'; readonly view: RascunhoFiscalView }
  | { readonly tipo: 'conflito'; readonly message: string }
  | { readonly tipo: 'erro'; readonly codigo?: string; readonly message: string };

export function caminhoRascunho(retornoId: string, sufixo = ''): string {
  return `/api/v1/vendas/fechamentos/${encodeURIComponent(retornoId)}/rascunho${sufixo}`;
}

/** POST em `/rascunho{sufixo}`; devolve a nova visão do rascunho ou o erro já em português. */
export async function escreverRascunho(retornoId: string, sufixo: string, corpo: unknown): Promise<ResultadoRascunho> {
  try {
    const resposta = await apiMutate(caminhoRascunho(retornoId, sufixo), { method: 'POST', body: corpo });
    if (resposta.ok) return { tipo: 'ok', view: (await resposta.json()) as RascunhoFiscalView };

    const erro = await lerErroApi(resposta, MENSAGEM_FALHA_RASCUNHO);
    if (resposta.status === 409 && erro.codigo === CODIGO_RASCUNHO_VERSAO_DESATUALIZADA) {
      return { tipo: 'conflito', message: MENSAGEM_RASCUNHO_DESATUALIZADO };
    }
    return { tipo: 'erro', ...(erro.codigo && resposta.status !== 403 ? { codigo: erro.codigo } : {}), message: erro.mensagem };
  } catch {
    return { tipo: 'erro', message: MENSAGEM_FALHA_RASCUNHO };
  }
}
